import { formatCount } from "@/lib/format";

/**
 * Desconto em fração para leitura, com até duas casas: "20%", "7.8%", "12.34%".
 *
 * A tela de ajuste e o card do Investimento usam o mesmo, para o desconto médio
 * não sair 9,75% numa e 9,8% na outra (EF-FUNC-010).
 */
export function formatDiscount(fraction: number | null | undefined): string {
  if (fraction == null) return "—";
  const hundredths = Math.round(fraction * 10000);
  const decimals = hundredths % 100 === 0 ? 0 : hundredths % 10 === 0 ? 1 : 2;
  return `${formatCount(hundredths / 100, { decimals })}%`;
}
